import React, { memo } from 'react';
import { Panel } from 'react-bootstrap';
import moment from 'moment';
import { USER_ROLES } from '../../../config/constants';

const ProductDiscussion = memo(({
                                    product,
                                    index,
                                    isOpen,
                                    onToggle,
                                    getRoleName
                                }) => {
    const discussion = (product.discussion || []).filter(item => !!item.message);

    if (!discussion.length) {
        return null;
    }

    const lastMessage = discussion[discussion.length - 1];
    const lastMessageClass = lastMessage.role === USER_ROLES.SUPPLIER ? "buy-red" : "buy-grean";

    return (
        <Panel
            expanded={isOpen}
            toggle="true"
            onToggle={() => {}}
            className="nested-custom-panel w-100">
            <Panel.Heading
                onClick={onToggle}
                className={`${lastMessageClass} message-container-style`}>
                <span>{getRoleName(lastMessage.role)} : {lastMessage.message}</span>
                <span>{moment(lastMessage.date).format("DD/MM/YYYY HH:mm")}</span>
            </Panel.Heading>
            <Panel.Collapse>
                <Panel.Body>
                    {discussion.map((item, idx) => {
                        const rowClass = item.role === USER_ROLES.SUPPLIER ? "buy-red" : "buy-grean";
                        return (
                            <div key={idx} className={`${rowClass} message-container-style`}>
                                <span>{getRoleName(item.role)} : {item.message}</span>
                                <span>{moment(item.date).format("DD/MM/YYYY HH:mm")}</span>
                            </div>
                        );
                    })}
                </Panel.Body>
            </Panel.Collapse>
        </Panel>
    );
}, (prevProps, nextProps) => {
    const prevDiscussion = (prevProps.product.discussion || []);
    const nextDiscussion = (nextProps.product.discussion || []);

    return (
        prevDiscussion.length === nextDiscussion.length &&
        prevProps.isOpen === nextProps.isOpen &&
        prevProps.product._id === nextProps.product._id
    );
});

export default ProductDiscussion;
